import { ContainerModule } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DISocketTypes } from './types';
import SocketClientFactory from '../SocketClientFactory';
import SocketConnection from '@framework/di/Providers/Socket/Connection';
import {
  ISocketClientFactoryMethod,
  ISocketClientFactory,
  ISocketDispatcherFactory,
  ISocketConnection,
  ISocketDispatcherFactoryMethod,
} from './interfaces';
import SocketDispatcherFactory from '../SocketDispatcher';

export const SocketModule = new ContainerModule(({ bind }) => {
  bind<ISocketConnection>(DISocketTypes.SocketConnection)
    .to(SocketConnection)
    .inSingletonScope();

  bind<ISocketClientFactory>(DISocketTypes.SocketClientFactory)
    .to(SocketClientFactory)
    .inSingletonScope();

  bind<ISocketDispatcherFactory>(DISocketTypes.SocketDispatcherFactory)
    .to(SocketDispatcherFactory)
    .inSingletonScope();

  bind<ISocketClientFactoryMethod>(DISocketTypes.SocketClient).toFactory(({ get }) =>
    (tenant?: DataroomTenant) => get<ISocketClientFactory>(DISocketTypes.SocketClientFactory).create(tenant),
  );

  bind<ISocketDispatcherFactoryMethod>(DISocketTypes.SocketDispatcher).toFactory(({ get }) =>
    (tenant?: DataroomTenant) => get<ISocketDispatcherFactory>(DISocketTypes.SocketDispatcherFactory).create(tenant),
  );
});
